export const isHlsMediaType = (mediaType) => {
    return !!(mediaType && mediaType.includes('mpegurl'));
};
export const isSupportedMediaType = (mediaType) => {
    const supportedMediaFormats = ['mp4', 'mpegurl'];
    return !!(mediaType && supportedMediaFormats.some(format => mediaType.includes(format)));
};
